import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "section-content"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", null, "Other Rooms", -1)
const _hoisted_4 = { class: "row rooms rooms--grid js-rooms-related slick--arrows-top" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_room_widget_mini = _resolveComponent("room-widget-mini")

  return (_ctx.rooms.length)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rooms, (room) => {
              return (_openBlock(), _createBlock(_component_room_widget_mini, {
                key: room.url,
                room: room
              }, null, 8, ["room"]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}